import { gql } from '@apollo/client'

export const ALL_DYNAMIC_COLUMNS_QUERY = gql`
  query AllDynamicColumnsQuery(
    $moduleName: String!
    $enabled: Boolean
    $table: String
  ) {
    allDynamicColumns(
      moduleName: $moduleName
      enabled: $enabled
      table: $table
    ) {
      edges {
        node {
          id
          name
          displayName
          enabled
          order
          inExport
          columnType
        }
      }
    }
  }
`
